var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNominals(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.76757 9.48302C10.4134 9.48302 10.6795 10.195 10.2627 10.7074L10.1985 10.7792L5.54199 15.5207C5.19449 15.8745 4.65909 15.8981 4.37318 15.5915L4.31589 15.5207L0.992172 10.7792C0.647769 10.2879 1.06895 9.55351 1.69641 9.48776L1.78739 9.48302H9.76757ZM6.45721 0.284345C6.80472 -0.0695065 7.34012 -0.0930966 7.62603 0.213575L7.68332 0.284345L11.007 5.02585C11.3514 5.51717 10.9303 6.25152 10.3028 6.31727L10.2118 6.32201H2.23164C1.5858 6.32201 1.31975 5.60999 1.73653 5.0976L1.80075 5.02585L6.45721 0.284345Z",
    fill: "#ECEAFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNominals);
export default __webpack_public_path__ + "static/media/nominals.56d685bb4ba07bd37a146718ffa7bb4c.svg";
export { ForwardRef as ReactComponent };